/*
* @Desc: vxe-table 一些拓展
* @Author: Wang Shuai
* @Date:   2022-08-30 10:20:58
* @Last Modified by:   Wang
* @Last Modified time: 2022-09-22 16:28:53
*/

import VXETable from 'vxe-table'

// 数字输入框
//onClick={ () => events.click(params) }
VXETable.renderer.add('number-input--edit', {
    // 可编辑激活模板
  	renderEdit (h, renderOpts, { row, column }) {
  		let { events } = renderOpts
  	  	return [
  	    	<vxe-input class="w-number-input" type="float" v-focus v-model={ row[column.property] } maxlength="12" controls={ false }></vxe-input>
  	  	]
  	},

  	// 可编辑模式查看模板
  	renderCell (h, renderOpts, { row, column }) {
  	  	return [
  	    	<span class="show-cell-text">{ row[column.property] }</span>
  	  	]
  	}
})

// 正式用的
VXETable.renderer.add('number-input--default', {
	// 默认显示模板
    renderDefault (h, renderOpts, params) {
      	let { row, column } = params
      	let { events, attrs } = renderOpts

        let { unit, showTableEdit } = attrs
        let fixedNum = [2, 4, 6][unit]

      	let requestChildren = row.children && row.children.length === 0
      	let requestColumn = ['otherCost']
      	let disabledRow = ['secondCost', 'reserveCost']
      	let requestCell = !disabledRow.includes(row.type) || requestColumn.includes(column.property)

        // 展示的值
        let value = row[column.property], showValue = ''
        switch (unit) {
            case 0:
                showValue = value ? parseFloat(this.$utils.multiply(value, 10000)).toFixed(2) : ''
                break;
            case 1:
                showValue = value ? parseFloat(value).toFixed(4) : ''
                break;
            case 2:
                showValue = value ? parseFloat(this.$utils.divide(value, 10000)).toFixed(6) : ''
                break
        }

        if (disabledRow.includes(row.type) && !requestColumn.includes(column.property)) {
            showValue = ''
        }

        // 如果是不可编辑模式
        if (!showTableEdit) {
            return [
                <span class="show-cell-text">{ showValue }</span>
            ]
        }


      	// 满足要求 是 编辑模式
      	if (requestChildren && requestCell) {
      		// 工程预备费特殊渲染
      		if (row.type === 'reserveCost' && column.property === 'otherCost') {
      			return [
      				<div class="percent-flex">
      					<vxe-input 
      						class="w-number-input percent-input" 
      						type="float" 
      						v-model={ row.otherCostRate } 
      						maxlength="6" 
      						min="0"
      						max="100"
      						controls={ false } 
      						onChange={ () => events && events.perChange ? events.perChange(params) : {} }
      					></vxe-input>
      					<span class="percent-icon">%</span>
      					<span class="percent-span">{ row.otherCost ? parseFloat(row.otherCost).toFixed(4) : '' }</span>
      				</div>
      			]
      		}

      		return [
      			<vxe-input 
      				class="w-number-input" 
      				type="float" 
      				v-model={ row[column.property] } 
                    digits="4"
      				maxlength="16" 
                    min="0"
      				controls={ false } 
      				onChange={ () => events && events.change ? events.change(params) : {} }
      			></vxe-input>
      		]
      	}

      	

      	
      	// 否则展示渲染
      	return [
      		<span class="show-cell-text">{ showValue }</span>
      	]
    }
})